export default __webpack_public_path__ + "static/media/website-brocoli.0698a103.png";